import { render, staticRenderFns } from "./TouristChat.vue?vue&type=template&id=e1ce9990&"
import script from "./TouristChat.vue?vue&type=script&lang=js&"
export * from "./TouristChat.vue?vue&type=script&lang=js&"
import style0 from "./TouristChat.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports